/**
 * AlmadarPostSoftwareThatSharesSLPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostSoftwareThatSharesSLPostPage
 */

import { useAlmadarPostSoftwareThatSharesSLPostPageLogic } from '@/hooks/traits/useAlmadarPostSoftwareThatSharesSLPostPageLogic';
import type { AlmadarPostSoftwareThatSharesSLPostPageConfig } from '@/hooks/traits/useAlmadarPostSoftwareThatSharesSLPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostSoftwareThatSharesSLPostView as AlmadarPostSoftwareThatSharesSLPostViewEntity } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { Box } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { AlmadarPostSoftwareThatSharesSLPostHeaderView } from '@/components/traits/AlmadarPostSoftwareThatSharesSLPostHeaderView';
import { AlmadarPostSoftwareThatSharesSLPostView } from '@/components/traits/AlmadarPostSoftwareThatSharesSLPostView';
import { AlmadarPostSoftwareThatSharesSLPostFooterView } from '@/components/traits/AlmadarPostSoftwareThatSharesSLPostFooterView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostSoftwareThatSharesSLPostPageViewProps {
  config?: Partial<AlmadarPostSoftwareThatSharesSLPostPageConfig>;
}

export function AlmadarPostSoftwareThatSharesSLPostPageView({ config: propsConfig }: AlmadarPostSoftwareThatSharesSLPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostSoftwareThatSharesSLPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostSoftwareThatSharesSLPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostSoftwareThatSharesSL" trait="AlmadarPostSoftwareThatSharesSLPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostSoftwareThatSharesSLPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostSoftwareThatSharesSLPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box bg="transparent" paddingY="xl" fullWidth={true}><Container size="xl" maxWidth="xl" padding="lg"><AlmadarPostSoftwareThatSharesSLPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostSoftwareThatSharesSLPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostSoftwareThatSharesSLPostPageView;
